'use client';

import { useMemo } from 'react';
import { CardIcons } from '../../consts/client-detail';
import type { CardType } from '../../types';

export const cardTypeMatchers: { type: CardType; pattern: RegExp }[] = [
  { type: 'Visa', pattern: /^4/ },
  { type: 'MasterCard', pattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)/ },
  { type: 'AmericanExpress', pattern: /^3[47]/ },
  { type: 'Discover', pattern: /^(6011|65|64[4-9]|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[01][0-9]|92[0-5]))/ },
];

export function useCardType(cardNumber: string) {
  const sanitized = cardNumber.replace(/\s+/g, '');

  const { type, Icon } = useMemo(() => {
    const match = cardTypeMatchers.find(({ pattern }) => pattern.test(sanitized));
    const type = match?.type ?? 'unknown';
    const Icon = CardIcons[type as keyof typeof CardIcons] ?? null;
    return { type, Icon };
  }, [sanitized]);

  return { type, Icon };
}
